function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.5,
    width: 15,
    height: 21,
    rx: 2,
    fill: "#1066B5",
    style: {
      fill: "#1066B5",
      fill: "color(display-p3 0.0627 0.4000 0.7098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.5,
    width: 15,
    height: 21,
    rx: 2,
    fill: "url(#paint0_linear_18787_1016)",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 2.75,
    width: 7.5,
    height: 7.5,
    fill: "#32A9E7",
    style: {
      fill: "#32A9E7",
      fill: "color(display-p3 0.1961 0.6627 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 10.25,
    width: 7.5,
    height: 7.5,
    fill: "#167EB4",
    style: {
      fill: "#167EB4",
      fill: "color(display-p3 0.0865 0.4946 0.7072)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10.25,
    width: 7.5,
    height: 7.5,
    fill: "#32A9E7",
    style: {
      fill: "#32A9E7",
      fill: "color(display-p3 0.1961 0.6627 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2.75,
    width: 7.5,
    height: 7.5,
    fill: "#58D9FD",
    style: {
      fill: "#58D9FD",
      fill: "color(display-p3 0.3451 0.8510 0.9922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18787_1016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 9,
    width: 18,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5H22C23.1046 9.5 24 10.3954 24 11.5V19.5C24 20.6046 23.1046 21.5 22 21.5H8C6.89543 21.5 6 20.6046 6 19.5V9.5Z",
    fill: "url(#paint1_linear_18787_1016)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18787_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9.5V12.5H22.5V9.5H24Z",
    fill: "#135298",
    style: {
      fill: "#135298",
      fill: "color(display-p3 0.0745 0.3216 0.5961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21.5V11L5.25 21.5H24Z",
    fill: "url(#paint2_linear_18787_1016)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21.5V11L24.75 21.5H6Z",
    fill: "url(#paint3_linear_18787_1016)",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.75C6 7.09315 7.34315 5.75 9 5.75H12C13.6569 5.75 15 7.09315 15 8.75V16.25C15 17.9069 13.6569 19.25 12 19.25H6V8.75Z",
    fill: "black",
    fillOpacity: 0.3,
    style: {
      fill: "black",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.25,
    width: 13.5,
    height: 13.5,
    rx: 2,
    fill: "url(#paint4_linear_18787_1016)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.0519V10.9273C10.5 8.76662 8.94541 7.25 6.76187 7.25C4.56646 7.25 3 8.77701 3 10.9481V11.0727C3 13.2334 4.55459 14.75 6.75 14.75C8.93354 14.75 10.5 13.223 10.5 11.0519ZM8.7318 11.0727C8.7318 12.5062 7.92484 13.3684 6.76187 13.3684C5.59889 13.3684 4.78006 12.4855 4.78006 11.0519V10.9273C4.78006 9.49377 5.58703 8.63158 6.75 8.63158C7.90111 8.63158 8.7318 9.51454 8.7318 10.9481V11.0727Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18787_1016",
    x1: 7.5,
    y1: 11,
    x2: 22.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484",
    style: {
      stopColor: "#064484",
      stopColor: "color(display-p3 0.0235 0.2667 0.5176)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5",
    style: {
      stopColor: "#0F65B5",
      stopColor: "color(display-p3 0.0588 0.3961 0.7098)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18787_1016",
    x1: 6,
    y1: 19.0769,
    x2: 24,
    y2: 19.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F",
    style: {
      stopColor: "#1B366F",
      stopColor: "color(display-p3 0.1059 0.2118 0.4353)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0",
    style: {
      stopColor: "#2657B0",
      stopColor: "color(display-p3 0.1490 0.3412 0.6902)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18787_1016",
    x1: 24,
    y1: 16.25,
    x2: 6,
    y2: 16.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD",
    style: {
      stopColor: "#44DCFD",
      stopColor: "color(display-p3 0.2667 0.8627 0.9922)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0",
    style: {
      stopColor: "#259ED0",
      stopColor: "color(display-p3 0.1451 0.6196 0.8157)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18787_1016",
    x1: 6,
    y1: 16.25,
    x2: 24,
    y2: 16.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0",
    style: {
      stopColor: "#259ED0",
      stopColor: "color(display-p3 0.1451 0.6196 0.8157)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD",
    style: {
      stopColor: "#44DCFD",
      stopColor: "color(display-p3 0.2667 0.8627 0.9922)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18787_1016",
    x1: 0,
    y1: 11,
    x2: 13.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484",
    style: {
      stopColor: "#064484",
      stopColor: "color(display-p3 0.0235 0.2667 0.5176)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5",
    style: {
      stopColor: "#0F65B5",
      stopColor: "color(display-p3 0.0588 0.3961 0.7098)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.418ce8fa938d32e566841ab639c7c0b5.svg";
export { ForwardRef as ReactComponent };